module.exports = __webpack_public_path__ + "img/newsLogo.3ed443d3.png";